import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgContentPasteOutlined = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "ContentPasteOutlined",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M7.91667 1.25008H6.175C6 0.766748 5.54167 0.416748 5 0.416748C4.45833 0.416748 4 0.766748 3.825 1.25008H2.08333C1.625 1.25008 1.25 1.62508 1.25 2.08341V8.75008C1.25 9.20841 1.625 9.58341 2.08333 9.58341H7.91667C8.375 9.58341 8.75 9.20841 8.75 8.75008V2.08341C8.75 1.62508 8.375 1.25008 7.91667 1.25008ZM5 1.25008C5.22917 1.25008 5.41667 1.43758 5.41667 1.66675C5.41667 1.89591 5.22917 2.08341 5 2.08341C4.77083 2.08341 4.58333 1.89591 4.58333 1.66675C4.58333 1.43758 4.77083 1.25008 5 1.25008ZM7.91667 8.75008H2.08333V2.08341H2.91667V3.33341H7.08333V2.08341H7.91667V8.75008Z",
			fill: "white"
		})
	})
});
export default SvgContentPasteOutlined;
